import { useQuery } from '@tanstack/react-query';
import { getChannel } from '@/services/whatsapp.service';

export function useWhatsAppChannel(orgId: string | undefined) {
  return useQuery({
    queryKey: ['whatsapp-channel', orgId],
    queryFn: () => getChannel(orgId!),
    enabled: !!orgId,
    staleTime: 60_000,
  });
}
